/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {inject, Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {RedirectService} from './redirect.service';
import {Environment, EnvironmentCabinet} from "compob2b-libs";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  environment = inject(Environment);

  constructor(private readonly auth: AuthService, private readonly redirectService: RedirectService, private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const allowAnonymousView = (this.environment as EnvironmentCabinet).allowAnonymousView;
    if (!allowAnonymousView && this.auth.isAnonymous()) {
      this.router.navigate(['/cabinet', 'sign-in']).then();
    } else {
      this.redirectService.next(state.url);
    }

    return this.auth.isAuthenticated();
  }
}
